import { client } from "./client";

const postFields = `
  _id,
  title,
  slug { current },
  excerpt,
  mainImage {
    asset -> { _id, url },
    alt
  },
  publishedAt,
  categories[]->{
    _id,
    title,
    description
  },
  author->{
    _id,
    name,
    slug { current },
    image { asset->{ _id, url } },
    jobTitle
  }
`;

export async function fetchPosts() {
  return client.fetch(
    `*[_type == "post"] | order(publishedAt desc) { ${postFields} }`
  );
}

export async function fetchCategories() {
  return client.fetch(
    `*[_type == "category"] | order(title asc) {
      _id,
      title,
      description,
      icon,
      slug { current }
    }`
  );
}

export async function fetchSinglePost(slug) {
  const result = await client.fetch(
    `*[_type == "post" && slug.current == $slug][0] {
      _id,
      title,
      slug { current },
      mainImage {
        asset -> { _id, url },
        alt
      },
      body,
      excerpt,
      publishedAt,
      categories[]-> { _id, title, description },
      author->{
        _id,
        name,
        slug { current },
        image { asset->{ _id, url } },
        jobTitle,
        bio
      }
    }`,
    { slug }
  );

  return result || null;
}

export async function fetchRecentPosts() {
  return client.fetch(
    `*[_type == "post"] | order(publishedAt desc)[0...3] { ${postFields} }`
  );
}

export async function getLatestBlogs() {
  return fetchRecentPosts();
}
